import {useMember} from "~/context/MemberContext";
import {createEffect, createSignal, Show} from "solid-js";
import {A, useIsRouting} from "@solidjs/router";
import {LinkButton} from "~/components/ui/Button";
import Popover from "~/components/ui/Popover";
import css from "./member-nav.module.css";
import {FaSolidCircleUser} from "solid-icons/fa";

export default function MemberNav() {

    const member = useMember()
    const [open, setOpen] = createSignal(false)
    const isRouting = useIsRouting()

    createEffect(() => {
        if (isRouting()) {
            setOpen(false)
        }
    })

    return (
        <Show when={member() != null}
              fallback={(
                  <LinkButton href="/auth/sign-in" variant="primary">Sign In</LinkButton>
              )}
        >
            <Popover
                open={open()}
                onOpenChange={details => setOpen(details.open)}
                trigger={(
                    <FaSolidCircleUser class={css.icon} aria-label="Member Navigation"/>
                )}
                content={(
                    <div class={css.nav}>
                        <Link href="/account/details" title="Account"/>
                        <Link href="/account/bookings" title="Bookings"/>
                        {/*<Link href="/account/billing" title="Billing"/>*/}
                        <Link href="/auth/sign-out" title="Sign Out" class={css.signOut}/>
                    </div>
                )}
            />
        </Show>
    )
}

function Link(props: { href: string, title: string, class?: string }) {
    return <A href={props.href} class={`${css.link} ${props.class}`.trim()} activeClass={css.active}>{props.title}</A>
}